import firebase from 'firebase/app';
import 'firebase/messaging';
import {FIRE_BASE_CONFIGURATION} from './Config'
let messaging;
if(firebase.messaging.isSupported()){
  firebase.initializeApp(FIRE_BASE_CONFIGURATION);
  messaging = firebase.messaging();
}
export{ messaging};
export default firebase;